<div class="avatar-container" (click)="onChangeImage()">
  @let imageUrlToDisplay = newUploadedImageUrl() || imageUrl() || fallbackImageUrl();
  <glxy-avatar [src]="imageUrlToDisplay" [svgIcon]="fallbackSvg()" [width]="220" />

  <div class="edit-overlay">
    <mat-icon>photo_camera</mat-icon>
  </div>
</div>
